import React, { useContext } from "react";
import { LanguageContext } from "../locales/LanguageContext";
import footerTranslations from "../locales/footerTranslations";

const Footer = () => {
  const { lang } = useContext(LanguageContext);
  const t = footerTranslations[lang] || {};
  return (
    <>
      <div className="footer_section">
        <div className="location_bg">
          <div className="container">
            <div className="location_main">
              <ul>
                <li>
                  <a
                    href="https://www.akaalkids.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="padding_15">🌐 www.akaalkids.com</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://wa.me/916283790049"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src="/assets/images/call-icon.png" alt={t.call} />
                    <span className="padding_15">{t.call}</span>
                  </a>
                </li>
                <li>
                  <a href="mailto:akaalkids@gmail.com">
                    <img src="/assets/images/mail-icon.png" alt={t.email} />
                    <span className="padding_15">{t.email}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright_section">
        <div className="container">
          <p className="copyright_text">
            {t.copyright}
            <a href="/">{t.akaalKids}</a>. {t.designedBy}
            <a target="_blank" rel="noreferrer" href="https://www.webenit.live">
              {t.webenit}
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
